export const styles = {
    container: {
        height: 'calc(100%)',
        // backgroundImage: `url(${signInBackground})`,
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'cover',
        backgroundColor: 'ffffff',
    },
    paper: {
        padding: '1.5rem',
        maxWidth: '34.5rem',
        minWidth: {
            sm: '26.5rem',
            xs: '0',
        },
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
        borderRadius: '1rem',
        textAlign: 'center',
        boxSizing: 'border-box',
    },
    title: {
        fontWeight: '400',
        fontSize: '2rem',
        lineHeight: '2.5rem',
        textAlign: 'center',
        color: '#000000',
        padding: '0 0 1rem',
    },
    subtitle: {
        padding: '0 0 1rem',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        textAlign: 'center',
        letterSpacing: '0.5px',
        color: '#000000',
    },
    logo: {
        width: '100%',
        textAlign: 'center',
        padding: '0 0 1rem',
    },
    resendButton: {
        backgroundColor: '#D0E8D8',
        color: '#0A1F16',
        boxShadow: 'none',
        border: 'none',
        padding: '0.625rem 1rem',
    },
};
